import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { withWidth } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import Grid from '@material-ui/core/Grid';
import { grey } from '@material-ui/core/colors';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import customClassName from '@configuratorware/configurator-frontendgui/App/Utils/customClassName';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import Notification from '@configuratorware/configurator-frontendgui/App/Shared/Components/Notification';
import AddToCart from '@configuratorware/configurator-frontendgui/App/Shared/Components/AddToBasket';
const styles = (theme) => ({
  dialogWrapper: {
    borderTop: '7px solid ' + theme.palette.primary.main,
    padding: '0 32px',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      padding: '0 16px',
    },
  },
  card: {
    marginBottom: 1,
    borderTop: '7px solid ' + theme.palette.primary.main,
    padding: 15,
    overflow: 'visible',
    [theme.breakpoints.between('xs', 'lg')]: {
      marginTop: 16,
    },
    [theme.breakpoints.down('xs')]: {
      overflow: 'hidden',
      display: 'flex',
      boxShadow: 'none',
      '&:last-child': {
        padding: '12px 0 0',
      },
      paddingTop: 0,
      borderTop: '1px solid ' + grey[500],
      borderRadius: 0,
      justifyContent: 'center',
    },
  },
  cardUnboxed: {
    borderTop: 'none',
    boxShadow: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
    },
  },
  mainButton: {
    margin: 0,
    padding: '6px 15px',
    height: 40,
    lineHeight: 1.5,
    [theme.breakpoints.down('xs')]: {
      height: 56,
    },
  },
  mainButtonLabel: {
    [theme.breakpoints.down('xs')]: {
      whiteSpace: 'normal',
      fontSize: 12,
    },
  },
  AmountPriceTypography: {
    textAlign: 'end',
    lineHeight: 1.2,
    [theme.breakpoints.down('xs')]: {
      padding: '3px 0',
      textAlign: 'start',
      fontSize: 12,
      lineHeight: 1,
    },
  },
  AmountPriceTypographyVat: {
    fontSize: 9,
    lineHeight: 1.2,
    textAlign: 'end',
    display: 'block',

    [theme.breakpoints.down('xs')]: {
      fontSize: 9,
      textAlign: 'start',
    },
  },
  cardActions: {
    padding: '8px 0',
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  closeIcon: {
    position: 'absolute',
    right: 32,
    top: 32,
    [theme.breakpoints.down('xs')]: {
      right: 16,
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  dialogTitleRoot: {
    padding: '20px 0',
  },
});

class AmountPrice extends React.Component {
  static propTypes = {
    boxed: PropTypes.bool,
    classes: PropTypes.object,
    amount: PropTypes.number,
    priceFormatted: PropTypes.string,
    vatNotice: PropTypes.string,
    ProductVariantComponent: PropTypes.elementType.isRequired,
    ConfigurationModeSwitchComponent: PropTypes.elementType.isRequired,
    showConfigurationModeSwitch: PropTypes.bool,
    error: PropTypes.object,
    width: PropTypes.string,
    hidePrices: PropTypes.bool,
    hidePieces: PropTypes.bool,
    priceList: PropTypes.array,
    title: PropTypes.string,
    showCallToAction: PropTypes.bool,
    onAddToBasket: PropTypes.func,
    bulkSavings: PropTypes.array,
    notifications: PropTypes.array,
    displayAcceptDesign: PropTypes.bool,
    bulkNameErrors: PropTypes.array,
    onShowChange: PropTypes.func,
    wrapperClass: PropTypes.string,
    validateConfiguration: PropTypes.func,
    addToCartPopUpLoader: PropTypes.bool,
    NotificationComponent: PropTypes.elementType,
    AddToCartComponent: PropTypes.elementType,
    renderPriceBox: PropTypes.func,
  };

  static defaultProps = {
    showCallToAction: true,
    showConfigurationModeSwitch: false,
    notifications: [],
    hidePieces: true,
    hidePrices: true,
    NotificationComponent: Notification,
    AddToCartComponent: AddToCart,
  };

  state = {
    showPriceOverview: false,
    notice: '',
    bulkNameErrors: [],
    approval: {
      value: false,
      error: null,
    },
    inView: true,
    showErrors: false,
    dataPrivacyAccepted: false,
  };

  onAddToBasket = async () => {
    await this.checkConfiguration();
    const { onAddToBasket } = this.props;
    onAddToBasket();
  };

  checkConfiguration = async () => {
    try {
      await this.props.validateConfiguration();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(`Error while validating configuration: ${e}`);
    }
  };

  render() {
    const {
      classes,
      boxed,
      showCallToAction,
      showConfigurationModeSwitch,
      ConfigurationModeSwitchComponent,
      wrapperClass,
    } = this.props;

    const boxStyle = boxed ? classes.card : classes.cardUnboxed;
    return (
      <div className={wrapperClass}>
        <Card className={clsx(boxStyle, customClassName('cta-box'))}>
          <Grid item xs={9} sm={12}>
            <CardActions className={classes.cardActions}>
              <Grid container spacing={1}>
                {showConfigurationModeSwitch && (
                  <Grid item xs={showCallToAction ? 6 : 12}>
                    <ConfigurationModeSwitchComponent
                      className={customClassName('configuration-type-button')}
                      classes={{
                        root: classes.mainButton,
                        label: classes.mainButtonLabel,
                      }}
                    />
                  </Grid>
                )}
                {showCallToAction && (
                  <AnalyticsWrapper targetId="add_to_cart">
                    <MainButton
                      className={customClassName('cta-button')}
                      variant="contained"
                      fullWidth
                      size="medium"
                      onClick={this.onAddToBasket}
                      classes={{
                        root: classes.mainButton,
                        label: classes.mainButtonLabel,
                      }}
                    >
                      {t('amountPrice.intoCart')}
                    </MainButton>
                  </AnalyticsWrapper>
                )}
              </Grid>
            </CardActions>
          </Grid>
        </Card>
      </div>
    );
  }
}

export default withWidth()(withStyles(styles, { name: 'AmountPrice' })(AmountPrice));
